import React from "react";
const Signature = () => {
  return (
    <div>
      <span className="signature">
        Designed & Built by <br /> Suman <span className="bi bi-heart-fill"/>{" "}
      </span>
    </div>
  );
};

export default Signature;
